import { Link } from "react-router-dom";

export function BrandLockup({ compact = false }) {
  return (
    <Link
      to="/"
      data-testid="brand-link"
      className="group inline-flex items-center"
      aria-label="Nivne Consulting Group"
    >
      <img
        src="/nivne-logo.png"
        alt="Nivne Consulting Group"
        className={compact ? "h-9 w-auto" : "h-10 md:h-12 w-auto"}
      />
    </Link>
  );
}
